import './main.css';
//import wrapStyles from "./styles/wrap.scss";
//import aboutStyles from "./styles/about.scss";
import cwsAboutStyles from "./styles/cwsabout.scss";
import baseStyles from "./styles/cws/base.scss";
import layoutStyles from "./styles/cws/layout.scss";
import styles from "./styles/cws/main.scss";
import mapStyles from "./styles/map_min.scss";

import { Elm } from './CWS.elm';
import * as serviceWorker from './serviceWorker';
import * as aboutContent from "./markdown/aboutContent.md"


import * as browserCheck from "./browserCheck.js"


//Map
import OldCore from "./PlugMapOld/Core.js";
import OldThemes from "./PlugMapOld/Plugins/Themes/index";
import OldExtent from "./PlugMapOld/Plugins/Extent/index";


import Core from "./PlugMap/Core"
import Themes from "./PlugMap/Plugins/Themes/index"
import Drawing from "./PlugMap/Plugins/Drawing/index";
import Identify from "./PlugMap/Plugins/Identify/index";

import config from "./mapConfig"
import referenceLayers from "./referenceConfig"

import * as summaryReport from "./Reports/peSummaryReport"
import * as canvg from 'canvg'



require("font-awesome-webpack-4");

var version = require("../package.json").version;

var elm = null;
var debug = false;



  function init(settings) {
    var b = browserCheck.describeBrowser();
    //mapConfig.layers = mapConfig.layers;
  
    //Here we are spitting out the config to the console to get the data migrated
    //console.log(JSON.stringify(mapConfig));
    //console.log(JSON.stringify(referenceConfig.fpConf));
    var vconfig = config;
    vconfig.pe.details.map.referenceLayers = referenceLayers.fpConf;
    var flags = {
      version: version,
      settings: settings,
      about : { contentPath: aboutContent },
      size: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      browser: browserCheck.describeBrowser(),
      refLayers: config.pe.details.map.referenceLayers,
      cws : vconfig,
      year: new Date().getFullYear().toString()
    }

    if(debug) console.log(flags);

    elm = Elm.CWS.init({
      node: document.getElementById('root'),
      flags: flags
    });

    safeSubscribe(elm, "preventLeave", preventLeave);
    safeSubscribe(elm, "allowLeave", allowLeave);
    
    safeSubscribe(elm, "logErrorCmd", errorWillRobinson);
    safeSubscribe(elm, "triggerAnimationCmd", triggerAnimation);
    safeSubscribe(elm, "openAuth", openAuth);

    window.app = elm;

    var wrap = {};
    window.wrap = wrap;
    
    wrap.app = app;

    safeSubscribe(elm, "setMapServices", vals => {
      wrap.ags = {}
      for(var svc of vals)
        wrap.ags[svc.key] = svc;
    })

    safeSubscribe(elm, "downloadFileCmd", info => {
      downloadFileOld(info);
    });

    safeSubscribe(elm, "peSummaryReport", vals => {
      var map = wrap.curMap.getMap();

      map.once('rendercomplete', function(event) {

        var canvas = event.context.canvas; //event.map.renderer_.canvas_;
        var mapImage = canvas.toDataURL('image/jpeg');

        var logoImage = document.getElementById("ReportLogo").children[0].src;

        var mitigationImage = document.getElementById("MitigationIcon").children[0].src;
        var preparednessImage = document.getElementById("PreparednessIcon").children[0].src;
        var preventionImage = document.getElementById("PreventionIcon").children[0].src;
        
        var drw = document.createElement("canvas")
        drw.width = 500;
        drw.height = 500;
        
        drw.getContext('2d').drawSvg(logoImage, 0, 0, 500, 500);
        logoImage = drw.toDataURL();

        canvg(drw, mitigationImage, 0, 0, 200, 200);
        mitigationImage = drw.toDataURL();

        canvg(drw, preparednessImage, 0, 0, 200, 200);
        preparednessImage = drw.toDataURL();

        canvg(drw, preventionImage, 0, 0, 200, 200);
        preventionImage = drw.toDataURL();

        var c = drw.toDataURL();


        var pc = vals.participationCommitment;

        var stats = vals.stats;

        var doc = summaryReport.makeReport(mapImage, logoImage, mitigationImage, preparednessImage, preventionImage,
        vals.peName,
        pc, stats
        )

        doc.save(vals.peName + " - Summary Report.pdf");

        safeSend(elm, "reportExported", null)

      });
      map.renderSync()

      
    })

    safeSubscribe(elm, "destructMapCmd", options => {
      if (wrap.curMap) wrap.curMap.destruct();
    });
    safeSubscribe(elm, "renderMapOld", options => {
      //TODO: We cant handle multiple maps...
      if (wrap.curMap) wrap.curMap.destruct();

      const core = new OldCore("map");
      core.init({}, wrap.app, options);

      core.register([
         [OldThemes, {}],
        [OldExtent, {}]
      ]);

      wrap.curMap = core;
    });

    safeSubscribe(elm, "renderMapCmd", options => {

      //TODO: We cant handle multiple maps...
      if (wrap.curMap) wrap.curMap.destruct();

      const core = new Core("map");
      core.init({}, wrap.app, options);

      core.register([
        [Themes, {}],
        [Drawing, {}],
        [Identify, {}]
      ]);

      wrap.curMap = core;
    });


    safeSubscribe(elm, "cws_upload_file_to_s3", model =>
    {
      if(debug) console.log("fileUpload");
    
      var upload = document.getElementById(model.field);
      if(debug) console.log(upload);

      if(debug) console.log("fileId to upload: " + model.info.fileId);
      if(debug) console.log("Selected file name: " + upload.files.item(0).name);
      if(debug) console.log("Selected file size: " + upload.files.item(0).size);
      if(debug) console.log("Selected file type: " + upload.files.item(0).type);
      if(debug) console.log("HAVE TO UPLOAD TO S3 USING fileId");

      let formData = new FormData();
      let req = new XMLHttpRequest();
      formData.append("file", upload.files.item(0), "aaa");
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", model.info.uploadUrl, true);
      //xhr.setRequestHeader("Content-Type", upload.files.item(0).type);
      var x = xhr.send(upload.files.item(0)); //formData);

      safeSend(elm, "cws_file_uploaded_to_s3", model.info);
      //upload(model.info, model.field, "cws_file_uploaded_to_s3")

      upload.value = '';
    });
    
  
    //This is the old version
    safeSubscribe(elm, "fileUploadjs", model => {
      upload(model, "fileUpload", "fileUploadedSub")
    });
  
  
  
    
  
    safeSubscribe(elm, "cws_file_get_file_info_with_id", getInfo => {
      var field = document.getElementById(getInfo[0]);
      if(field)
      {
        let file = field.files.item(0);
        if(!file)
          return;
        let resp = 
          { name : file.name
          , type_ : file.type
          , size: file.size
          }
        safeSend(elm, "cws_file_info_with_id_response",
          { id: getInfo[1]
          , info : resp
          }
        );
      }
    })
    
  
    safeSubscribe(elm, "getFileInfo", function(model) {
      getFileInfo("fileUpload", "fileInfoSub");
    });

    safeSubscribe(elm, "getPeFileInfo", function(model) {    
      var upload = document.getElementById("fileUpload");    
      safeSend(elm, "fileInfoSub", upload.files.item(0));
    });

    safeSubscribe(elm, "pickFileFor", function(model) {
      if(debug) console.log("Manual upload top")
      var elementId =  "pickFileFor" + model;

      var elem = document.getElementById(elementId);

      //If the element exists. Kill it.
      if(elem)
      {
        document.body.removeChild(elem);
        elem = null;
      }

      while(!document.getElementById(elementId))
      {
        if(debug) console.log("Attempting to recreate the element");
        elem = document.createElement("input");
        elem.type = "file";
        elem.id = elementId;
        elem.className = "hidden";
        document.body.appendChild(elem);
      }

      elem.onchange = evt => {
        let file = elem.files.item(0);
        if(!file)
          return;
          
        let resp = 
          { name : file.name
          , type : file.type
          , size: file.size
          }
          
        var ret = 
          { file: resp
          , for: model
          };
        safeSend(elm, "filePickedFor", ret);
      }

      //Click our element
      elem.click();
    })

    safeSubscribe(elm, "uploadPickedFileFor", function(model) {

      var elementId =  "pickFileFor" + model.id;

      if(debug) console.log("fileUpload");
    
      var upload = document.getElementById(elementId);
      if(debug) console.log(upload);

      if(debug) console.log("fileId to upload: " + model.info.fileId);
      if(debug) console.log("Selected file name: " + upload.files.item(0).name);
      if(debug) console.log("Selected file size: " + upload.files.item(0).size);
      if(debug) console.log("Selected file type: " + upload.files.item(0).type);
      if(debug) console.log("HAVE TO UPLOAD TO S3 USING fileId");

      let formData = new FormData();
      let req = new XMLHttpRequest();
      formData.append("file", upload.files.item(0), "aaa");
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", model.info.uploadUrl, true);
      
      var x = xhr.send(upload.files.item(0));

      safeSend(elm, "cws_file_uploaded_to_s3", model.info);

      upload.value = '';

    })


  }
  
function downloadFileOld(info) {
  var model = info[0];
  var prepend = info[1] != undefined ? info[1] + "-" : "";
  var req = new XMLHttpRequest();
  req.open("GET", model.uploadUrl, true);
  req.responseType = "blob";
  var _this = this;
  var that = _this;
  var caller = _this;

  req.onload = function(evt) {
    var blob, clickEvent, link;

    blob = void 0;
    clickEvent = void 0;
    link = void 0;
    blob = evt.currentTarget.response;

    if (typeof window.navigator.msSaveBlob !== "undefined") {
      window.navigator.msSaveBlob(blob, prepend + model.file.name);
    } else {
      link = document.createElement("a");
      link.setAttribute("href", window.URL.createObjectURL(blob));
      link.setAttribute("download", prepend + model.file.name);
      clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false
      });
      link.dispatchEvent(clickEvent);
    }
  };

  req.send();
}

function getFileInfo(field, response)
  {
    var upload = document.getElementById(field);    
    safeSend(elm, response, upload.files.item(0));
  }

function initError(error) {
  let errorDiv = document.createElement("div");
  errorDiv.innerHTML =
    "There was an error processing your request. Please try again.";
  let contentDiv = document.createElement("div");
  contentDiv.innerHTML = error.message;

  document.getElementById("root").append(errorDiv);
  document.getElementById("root").append(contentDiv);
}

function safeSubscribe(elm, port, fun) {
  if (elm) {
    if (elm.ports) {
      if (elm.ports[port]) {
        return elm.ports[port].subscribe(fun);
      } else {
        console.warn(
          "Port '" + port + "' not found. Has the code been removed?"
        );
      }
    }
  }
}

function safeSend(elm, port, data) {
  if (elm) {
    if (elm.ports) {
      if (elm.ports[port]) {
        return elm.ports[port].send(data);
      } else {
        console.warn(
          "Port '" + port + "' not found. Has the code been removed?"
        );
      }
    }
  }
}

function triggerAnimation(name) {
  requestAnimationFrame(() => {
    safeSend(elm, "triggerAnimationSub", name);
  });
}

function errorWillRobinson(error) {
  console.error(error);
}

function preventLeave() {
  
  window.onbeforeunload = function() {
    //Uncomment if we actually need to show the inapp modal
    //safeSend(elm, 'leaveAttempted', null);
    return true;
  };
}

function allowLeave() {
  window.onbeforeunload = null;
}


function openAuth(url) {
  if(window.AuthWindow)
    window.authWindow.close();

  window.authWindow = window.open(url);
}

window.addEventListener("message", receiveMessage, false);


function upload(model, field, response) {
  if(debug) console.log("fileUpload");
  
  var upload = document.getElementById(field);
  if(debug) console.log(upload);

  if(debug) console.log("fileId to upload: " + model.fileId);
  if(debug) console.log("Selected file name: " + upload.files.item(0).name);
  if(debug) console.log("Selected file size: " + upload.files.item(0).size);
  if(debug) console.log("Selected file type: " + upload.files.item(0).type);
  if(debug) console.log("HAVE TO UPLOAD TO S3 USING fileId");

  let formData = new FormData();
  let req = new XMLHttpRequest();
  formData.append("file", upload.files.item(0), "aaa");
  var xhr = new XMLHttpRequest();
  xhr.open("PUT", model.uploadUrl, true);
  //So if its edge the header is already set
  //xhr.setRequestHeader("Content-Type", upload.files.item(0).type);
  var x = xhr.send(upload.files.item(0)); //formData);

  safeSend(elm, response, { msg: "done" });
}


function receiveMessage(event) {
  if (event.data && event.data.source == "oAuth" && event.data.data) {
    switch (event.data.data.status) {
      case "Code Received":
        safeSend(elm, "oAuthCodeReceived", event.data.data.code);
        if(window.AuthWindow)
          window.authWindow.close();
        break;
      default:
        //We shouldnt get here ...
        debugger;
    }
  }
}


if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) { 
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

function mergeDeep(target, source) {
  let output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target))
          Object.assign(output, { [key]: source[key] });
        else
          output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}

window
  .fetch("/appsettings.json")
  .then(function(response) {
    return response.json();
  })
  .then(function(myJson) {
    if(myJson.development)
    {
      window
      .fetch("/appsettings.override.json")
      .then(function(resp) {
        return resp.json();
      })
      .then(function(overrideJson) {
        var merged = mergeDeep(myJson, overrideJson); //TODO: This wont work in ie11
        init(merged);
      })
      .catch(function(error) {
        init(myJson);
      });
    }
    else
    {
      init(myJson);
    }
  })
  .catch(function(error) {
    initError(error);
  });


serviceWorker.register();